@use '@helsenorge/designsystem-react/scss/font-settings' as font-settings;

.errormessage {
  &__correlationid {
    font-size: font-settings.$font-size-xs;
    line-height: font-settings.$lineheight-size-xs;
  }

  &__debug {
    font-size: font-settings.$font-size-xs;
    line-height: font-settings.$lineheight-size-xs;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}
